import { LoadState } from "../../constants/enums";

export interface IFoodState {
  list: IFoodMenu[];
  loading: LoadState;
  totalRecords: number;
  data: IFoodMenu;
  dataLoading: LoadState;
  error: string | null;
}

export interface IFoodMenu {
  food_menu_uuid: string | null;
  dietary_type: string | null;
  menu_json: IFoodMenuJson[];
  dietary_order_preferance: number;
  company_outlet_uuid: string;
	company_outlet_name: string;
}

export interface IFoodMenuJson {
  food_category_name: string | null;
  food_category_types: IFoodSubCategory[];
}

export interface IFoodSubCategory {
  food_catgory_type_name: string | null;
  food_list: IFoodData[];
}

export interface IFoodData {
  food_name: string | null;
  food_price: string | null;
  food_img: string | null;
}

export const initialFoodState: IFoodState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  data: {
    food_menu_uuid: null,
    dietary_type: "",
    company_outlet_uuid: "",
		company_outlet_name: "",
    dietary_order_preferance: 0,
    menu_json: [{
      food_category_name: "",
      food_category_types: [
        {
          food_catgory_type_name: "",
          food_list: [
            {
              food_name: "",
              food_price: "",
              food_img: ""
            }
          ]
        }
      ]
    }]
  },
  dataLoading: LoadState.NotLoaded,
  error: null,
};

